import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary caught:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen bg-[#FFF8F0] flex items-center justify-center p-6" data-testid="error-boundary">
          <div className="max-w-md text-center space-y-6">
            <div className="w-20 h-20 mx-auto bg-hoi-coral/10 flex items-center justify-center" style={{ borderRadius: '50%' }}>
              <span className="text-3xl">!</span>
            </div>
            <h1 className="font-heading font-bold text-2xl text-black">Er ging iets mis</h1>
            <p className="text-gray-600">Sorry, er is een fout opgetreden. Klik hieronder om opnieuw te laden.</p>
            <button
              onClick={() => {
                localStorage.removeItem('token');
                window.location.href = '/';
              }}
              className="bg-hoi-coral text-black font-heading font-bold px-8 py-3 hover:bg-hoi-coral/90 transition-colors"
              data-testid="error-reload-btn"
            >
              Opnieuw laden
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
